<template>
    <div class="modal fade" :id="modalId" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered modal-sm">
        <div class="modal-content modal-clean">
  
          <!-- Icon -->
          <div class="modal-icon-wrap">
            <div class="modal-icon modal-icon--danger">
              <font-awesome-icon :icon="icon" />
            </div>
          </div>
  
          <!-- Body -->
          <div class="modal-body-clean">
            <p class="modal-heading">{{ title }}</p>
            <p class="modal-subtext" v-html="modalText"></p>
          </div>
  
          <!-- Actions -->
          <div class="modal-actions">
            <button type="button" class="modal-btn modal-btn--cancel" data-bs-dismiss="modal">
              Cancel
            </button>
            <button
              type="button"
              class="modal-btn modal-btn--danger"
              data-bs-dismiss="modal"
              @click.prevent="actionButton"
            >
              <font-awesome-icon :icon="confirmIcon" class="me-2" />
              {{ confirmLabel }}
            </button>
          </div>
  
        </div>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    props: {
      modalId:      { type: String, required: true },
      modalText:    { type: String, default: 'This action will be applied to all selected items and cannot be undone.' },
      title:        { type: String, default: 'Confirm Bulk Action?' },
      confirmLabel: { type: String, default: 'Confirm' },
      confirmIcon:  { type: String, default: 'check' },
      icon:         { type: String, default: 'tasks' },
    },
  
    setup(_, { emit }) {
      const actionButton = () => emit('deleteBulk');
      return { actionButton };
    },
  };
  </script>
  
  <style scoped>
  .modal-clean {
    border: none;
    border-radius: 16px;
    box-shadow: 0 20px 60px rgba(0,0,0,.14);
    overflow: hidden;
  }
  
  .modal-icon-wrap {
    display: flex;
    justify-content: center;
    padding: 28px 24px 0;
  }
  
  .modal-icon {
    width: 60px;
    height: 60px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 26px;
  }
  .modal-icon--danger { background: rgba(224,53,53,.1); color: #e03535; }
  
  .modal-body-clean {
    padding: 16px 28px 8px;
    text-align: center;
  }
  .modal-heading { font-size:17px; font-weight:700; color:#1a2b45; margin:0 0 8px; }
  .modal-subtext { font-size:13.5px; color:#7a90b0; margin:0; line-height:1.6; }
  
  .modal-actions {
    display: flex;
    gap: 10px;
    padding: 18px 24px 24px;
    justify-content: center;
  }
  
  .modal-btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 13px;
    font-weight: 600;
    padding: 9px 22px;
    border-radius: 8px;
    border: none;
    cursor: pointer;
    transition: background .15s;
    flex: 1;
  }
  .modal-btn--cancel { background:#f4f7fb; color:#1a2b45; border:1px solid #dde5f0; }
  .modal-btn--cancel:hover { background:#e8eef6; }
  .modal-btn--danger { background:#e03535; color:#fff; }
  .modal-btn--danger:hover { background:#c42b2b; }
  
  .me-2 { margin-right: 6px; }
  </style>